const OrderList = () => import('@/pages/order-manage/OrderList');
const OrderDetail = () => import('@/pages/order-manage/OrderDetail');
const AddOrder = () => import('@/pages/order-manage/AddOrder');
const FollowRecord = () => import('@/pages/order-manage/FollowRecord');

export default[
    {
      path: '/order-list',
      component: OrderList,
      meta: [
        {
          name: '订单管理',
          url: '',
        },
        {
          name: '订单列表',
          url: '',
        },
      ],
    },
    {
      path: '/order-list/order-detail',
      component: OrderDetail,
      meta: [
        {
          name: '订单管理',
          url: '/order-list',
        },
        {
          name: '订单列表',
          url: '/order-list',
        },
        {
          name: '订单详情',
          url: '',
        },
      ],
    },
    {
      path: '/order-list/add-order',
      component: AddOrder,
      meta: [
        {
          name: '订单管理',
          url: '/order-list',
        },
        {
          name: '订单列表',
          url: '/order-list',
        },
        {
          name: '新建订单',
          url: '',
        },
      ],
    },
    {
      path: '/order-list/order-record',
      component: FollowRecord,
      meta: [
        {
          name: '订单管理',
          url: '/order-list',
        },
        {
          name: '订单列表',
          url: '/order-list',
        },
        {
          name: '订单记录',
          url: '',
        },
      ],
    },
]
